// path: frontend/src/hooks/useProjectActions.js
/**
 * Действия над проектом, общие для канбана и списка.
 * Проверка допустимости перехода — из project.permissions.allowedStatuses
 * (сервер: domain/permissions.ts::canChangeProjectStatus, effective-роль,
 * scope, тип проекта). Окончательная проверка — в ProjectService.update.
 *
 * Параметр ur намеренно не деструктурируется: все RBAC-флаги приходят
 * в project.permissions, а не вычисляются на клиенте. Вызывающий код
 * может продолжать передавать ur — JS проигнорирует лишнее поле.
 */
import { DIALOGS, TOASTS } from "../utils/constants";
import { useEventCallback } from "./useEventCallback";
import { useUpdateProjectMutation } from "../api/queries/projects";

export function useProjectActions({ db, toast, confirm }) {
  const updateMutation = useUpdateProjectMutation();

  const handleMove = useEventCallback(async (id, newStatus) => {
    const project = db.projects.find((p) => p.id === id);
    if (!project || project.status === newStatus) return;

    const allowed = project.permissions?.allowedStatuses ?? [];
    if (!allowed.includes(newStatus)) {
      toast("У вас нет прав на изменение статуса этого проекта.", "error");
      return;
    }

    if (newStatus === "closed" || newStatus === "cancelled") {
      const dialog =
        newStatus === "closed"
          ? DIALOGS.closeProject(project.name)
          : DIALOGS.cancelProject(project.name);
      if (!(await confirm(dialog))) return;
    }

    try {
      await updateMutation.mutateAsync({ id, body: { status: newStatus } });
      if (newStatus === "closed") toast(TOASTS.projectClosed, "success");
      else if (newStatus === "cancelled")
        toast(TOASTS.projectCancelled, "success");
    } catch (err) {
      toast(err.message || "Ошибка изменения статуса", "error");
    }
  });

  return { handleMove };
}
